import { RootState } from './../../../store/rootState';
import { IUser } from '../../../types/auth';
import { createSelector } from 'reselect'
import { IEmployee } from '../../settings/types/employee'
import { IWizardProject } from '../types/wizardData';


const getProjectWizardDataState = (state: RootState) => state.projectsState.wizardApp.projectWizardData
const getEmployeesState = (state: RootState): IEmployee[] => state.userSettingsState.employees
const loggedInUSer = (state: RootState) => state.authState.user
const getWizzardStep = (state: RootState) => state.projectsState.wizardApp.wizardStep

export const getProjectWizardDataSelector = createSelector(
  getProjectWizardDataState,
  loggedInUSer,
  getEmployeesState,
  getWizzardStep,
  (wizardData: IWizardProject, user: IUser | null, employess: IEmployee[], wizardStep: string ) => {
    let selectedEmployee = undefined
    if (user !== null && !user.is_superuser) {
      selectedEmployee = employess.find(emp => emp.username === user.username)
    }
    const _employees = wizardStep === 'step-four' ? selectedEmployee !== undefined ? [{...selectedEmployee}, ] : [] : [...wizardData.employees]
    const _wizardData = {...wizardData, employees: wizardData.employees.length === 0 ? [..._employees] : [...wizardData.employees]}

    return _wizardData
  }
)
